// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MfCKI","closeIcon":"styles_closeIcon__a95hM","content":"styles_content__uElFc","title":"styles_title__z-LjH","buttonWrapper":"styles_buttonWrapper__PJ8az"};